<template>
	<screen class="change-pass-view">
		<template slot="header">
			<ui-header type="dark" @click="onBack">
				<h2 slot="title">Change Password</h2>
				Change the password for your account below.
			</ui-header>
		</template>
		<div class="change-pass-content">
			<form v-on:submit.prevent="onSubmit">
				<label>
					<ui-input
						placeholder="Current Password"
						native-type="password"
						v-model="passwords.old_password"
					/>
				</label>
				<label>
					<ui-input
						placeholder="New Password"
						native-type="password"
						v-model="passwords.new_password"
					/>
				</label>
				<label>
					<ui-button native-type="submit" :loading="isLoading"
						>Change Password</ui-button
					>
				</label>
			</form>
		</div>
	</screen>
</template>

<script>
import { mapActions } from 'vuex'
import UiButton from '../../ui/Button'
import UiInput from '../../ui/Input'
import UiHeader from '../../ui/Header'
import Screen from '../../ui/Screen'

export default {
	name: 'change-pass-view',
	components: { UiButton, UiInput, UiHeader, Screen },
	data() {
		return {
			isLoading: false,
			passwords: {
				old_password: '',
				new_password: ''
			}
		}
	},
	methods: {
		...mapActions(['changePassword']),
		onSubmit() {
			this.isLoading = true
			this.changePassword(this.passwords)
				.then(() => {
					this.isLoading = false
					this.navigate({ name: 'settings' }, 'back')
				})
				.catch(({ message }) => {
					this.isLoading = false
					this.$swal('Error', message)
				})
		},
		onBack() {
			this.navigate({ name: 'settings' }, 'back')
		}
	}
}
</script>

<style lang="scss">
.change-pass-view {
	.change-pass-content {
		padding: 15px 0px;
	}
}
</style>
